module.exports = __webpack_public_path__ + "img/Icon - Report or Flag.d9978f39.svg";